/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGemStone = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.445 2.168a1 1 0 0 1 1.11 0L19 6.465v11.07l-6.445 4.297a1 1 0 0 1-1.11 0L5 17.535V6.465zM7 8.802v6.396l2-1.666v-3.064zm4 1.612v3.172l1 1 1-1v-3.172l-1-1zm2-2.828 1.061 1.061 2.048-1.706L13 4.869zm-2-2.717L7.891 6.94 9.94 8.647 11 7.586zm6 3.933-2 1.666v3.064l2 1.666zm-.891 8.257-2.048-1.706L13 16.414v2.717zM11 19.131v-2.717l-1.061-1.061-2.048 1.706z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGemStone as GemStone };
